import { render } from "./SearchBoxHome.vue?vue&type=template&id=618fc7a6&scoped=true&ts=true"
import script from "./SearchBoxHome.vue?vue&type=script&lang=ts"
export * from "./SearchBoxHome.vue?vue&type=script&lang=ts"

import "./SearchBoxHome.vue?vue&type=style&index=0&id=618fc7a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618fc7a6"]])

export default __exports__